import PaginationProduct from "./PaginationProduct";

export default PaginationProduct;
